(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["intg-predictive"] && !Shopify.designMode) return;
  try {
    class IntgPredictive extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.panel = this.querySelector('[data-intg-pred-panel]');
    this.status = this.querySelector('[data-intg-pred-status]');
    if (!this.input || !this.panel) return;

    this.endpoint = (this.dataset.suggestUrl || '/search/suggest') + '.json';
    this.limit = parseInt(this.dataset.limit, 10) || 6;
    this.currency = this.dataset.currency || 'EUR';
    this.locale = document.documentElement.lang || 'it';
    this.cache = new Map();
    this.seq = 0;
    this.active = -1;
    this.links = [];

    this.input.setAttribute('autocomplete', 'off');
    this.input.setAttribute('spellcheck', 'false');
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKey.bind(this));
    this.input.addEventListener('focus', this.onInput.bind(this));
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }

  formatMoney(value) {
    const amount = parseFloat(value);
    if (isNaN(amount)) return '';
    try {
      const parts = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).formatToParts(1);
      const symbol = parts.find((p) => p.type === 'currency');
      const number = new Intl.NumberFormat(this.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
      return symbol ? symbol.value + number : number;
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  onInput() {
    const term = this.input.value.trim();
    if (term.length < 2) {
      this.close();
      return;
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.fetchTerm(term), 200);
  }

  fetchTerm(term) {
    if (this.cache.has(term)) {
      this.render(this.cache.get(term));
      return;
    }
    const token = ++this.seq;
    const url = this.endpoint + '?q=' + encodeURIComponent(term) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=' + this.limit;
    fetch(url)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        if (token !== this.seq) return;
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.cache.set(term, products);
        this.render(products);
      })
      .catch(() => {
        if (token === this.seq) this.close();
      });
  }

  render(products) {
    this.panel.textContent = '';
    this.links = [];
    this.active = -1;

    if (!products.length) {
      const empty = document.createElement('p');
      empty.className = 'intg-pred__empty';
      empty.textContent = this.panel.dataset.labelEmpty || '';
      this.panel.appendChild(empty);
      this.open(0);
      return;
    }

    products.forEach((product, index) => {
      const link = document.createElement('a');
      link.className = 'intg-pred__item';
      link.href = product.url;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.id = this.panel.id + '-opt-' + index;

      const thumb = document.createElement('span');
      thumb.className = 'intg-pred__thumb';
      const src = (product.featured_image && product.featured_image.url) || product.image;
      if (src) {
        const img = document.createElement('img');
        img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 46;
        img.height = 46;
        thumb.appendChild(img);
      }
      link.appendChild(thumb);

      const body = document.createElement('span');
      body.className = 'intg-pred__body';
      const metaText = [product.vendor, product.type].filter(Boolean).join(' // ');
      if (metaText) {
        const meta = document.createElement('span');
        meta.className = 'intg-pred__meta';
        meta.textContent = metaText;
        body.appendChild(meta);
      }
      const title = document.createElement('span');
      title.className = 'intg-pred__title';
      title.textContent = product.title;
      body.appendChild(title);
      link.appendChild(body);

      const prices = document.createElement('span');
      prices.className = 'intg-pred__prices';
      const price = document.createElement('span');
      price.className = 'intg-pred__price';
      price.textContent = this.formatMoney(product.price);
      prices.appendChild(price);
      const compare = parseFloat(product.compare_at_price_min);
      if (!isNaN(compare) && compare > parseFloat(product.price)) {
        const was = document.createElement('s');
        was.className = 'intg-pred__was';
        was.textContent = this.formatMoney(compare);
        prices.appendChild(was);
      }
      link.appendChild(prices);

      this.panel.appendChild(link);
      this.links.push(link);
    });

    this.open(products.length);
  }

  open(count) {
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    if (this.status) {
      const template = this.panel.dataset.labelCount || '';
      this.status.textContent = count ? template.replace('__n__', count) : (this.panel.dataset.labelEmpty || '');
    }
  }

  close() {
    this.panel.hidden = true;
    this.panel.textContent = '';
    this.links = [];
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    if (this.status) this.status.textContent = '';
  }

  highlight(index) {
    this.links.forEach((link, i) => {
      const on = i === index;
      link.classList.toggle('is-active', on);
      link.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.active = index;
    if (index > -1) {
      this.input.setAttribute('aria-activedescendant', this.links[index].id);
      this.links[index].scrollIntoView({ block: 'nearest' });
    } else {
      this.input.removeAttribute('aria-activedescendant');
    }
  }

  onKey(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }
    if (this.panel.hidden || !this.links.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.highlight((this.active + 1) % this.links.length);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.highlight(this.active <= 0 ? this.links.length - 1 : this.active - 1);
    } else if (event.key === 'Enter' && this.active > -1) {
      event.preventDefault();
      window.location.href = this.links[this.active].href;
    }
  }
}

if (!customElements.get('intg-predictive')) {
  customElements.define('intg-predictive', IntgPredictive);
}
  } catch(e) { console.error(e); }
})();

})();
